import React from "react";
import { Routes, Route } from "react-router-dom";
import { PublicRoute } from "utility/routes";
import Login from "views/Login";
import AppRouter from "router/appRouter";

function RootRouter() {
  return (
    <Routes>
      {/* Add those routes here which do not need any layout such as login etc. */}
      <Route path="/login" element={<PublicRoute element={<Login />} />} />
      <Route path="/*" element={<AppRouter />} />
    </Routes>
  );
}

export default RootRouter;
